import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  inspirationVoxboxSection: (bg: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes = 0) => ({
    p: ['64px 40px 64px 40px', '64px 40px 64px 40px', '80px 64px 80px 64px', '80px 64px 80px 64px', '6.041666667vw 10.15625vw 6.041666667vw 10.15625vw'],
    mt: MARGINS_BLOCKS[marginTop],
    mb: MARGINS_BLOCKS[marginBottom],
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    rowGap: 'auto',
    justifyContent: 'space-between',
    bg,
    overflowX: 'hidden',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: ['100%', '100%', '100%', '100%', '38.125vw']
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    width: ['100%', '100%', '100%', '100%', '31.165452653vw'],
    justifyContent: ['flex-end', 'flex-end', 'flex-end', 'flex-end', 'flex-end', 'flex-end', 'flex-end', 'center']
  },
  subtitle: color => ({
    mt: ['8px', '8px', '8px', '8px', '16px'],
    fontSize: [theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h3],
    lineHeight: '140%',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    color: color || theme.rawColors.darkGrey700
  }),
  videoWrapper: {
    mt: ['24px', '24px', '40px', '40px', '0'],
    minWidth: '258px'
  },
  description: color => ({
    m: ['24px 0 24px', '24px 0 24px', '40px 0 24px', '40px 0 24px', '16px 0 24px'],
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    lineHeight: '175%',
    color: color || theme.rawColors.darkGrey700
  }),
  linkButton: (marginTop: number) => ({
    mt: `${marginTop}px`
  })
};